module.exports = __webpack_public_path__ + "assets/img/ST.2b85bb4c.png";